import axios from 'axios';

const SITE_URL =
  typeof process !== 'undefined' && process.env.SITE_URL ? process.env.SITE_URL : 'http://localhost:3000';

// Need to use an absolute URL for SSR
const axiosInstance = axios.create({
  baseURL: typeof window !== 'undefined' ? '' : SITE_URL, // Check for client-side vs. server-side
});

export default axiosInstance;
